/**
 * author: Soumya Shreyas
 */

import React, { useEffect, useState, useContext } from "react";
import { Button, Modal, Accordion, ListGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-dropdown-tree-select/dist/styles.css";
import "react-multi-email-input/dist/style.css";
import FormService from "../../core/services/FormService";
import {
  GlbFormContext,
  AssessmentShareTokenContext,
} from "../../App";

function SharedWith({ modalShow, callbackModal }) {
  const [show, setShow] = useState(modalShow);
  const { glbForm, setGlbForm } = useContext(GlbFormContext);
  const { shareToken, setShareToken } = useContext(AssessmentShareTokenContext);
  const [data, setData] = useState([]);
  var arr_values = [];

  useEffect(() => {
    getSharedWithDetails();
  }, []);
  const handleClose = () => {
    setShow(false);
    callbackModal(false);
  };
  const getSharedWithDetails = () => {
    FormService.sharedWithDetails(glbForm.id)
      .then((response) => {
        setData([...response.data]);
      })
      .catch((error) => {
        let errormsg = error.response.data.message
          ? error.response.data.message
          : error.message;
        toast.error(errormsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  const handleShare = (token) => {
    setShareToken(token);
    callbackModal(false);
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Shared With</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Accordion>
          {data.length > 0 &&
            data?.map((item, index) => (
              <Accordion.Item eventKey={index} key={index}>
                <Accordion.Header>{glbForm.name} - {FormService.formatDate(item.createdOn)}</Accordion.Header>
                <Accordion.Body>
                  <ListGroup as="ol" numbered key={item.id} className="mb-3">
                    {item?.shareDetails?.length > 0 &&
                      item?.shareDetails?.map((list) => (
                        <ListGroup.Item
                          as="li"
                          className="d-flex justify-content-between align-items-start "
                          key={list.id}
                        >
                          <div className="ms-2 me-auto" key={list.id} >
                            <div className="fw-bold">{list.email}</div>
                            {list?.sections?.length > 0 &&
                              list?.sections?.map((section) => (
                                <div key={section.id}>{section.title}</div>
                              ))}
                          </div>
                        </ListGroup.Item>
                      ))}
                  </ListGroup>
                  <div>
                    <Button
                      variant="primary"
                      onClick={() => handleShare(item.parentAccessToken)}
                    >
                      Share +
                    </Button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} autoFocus>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SharedWith;
